<template>
  <header class="c-header" :class="{'isHide': isHide}">
    <a class="c-header__logoST50" :href="urls.page_top">
      <img v-if="logoFile" :src="`${assets_path}images/common/${logoFile}`" :alt="logoAlt" width="393" height="21">
    </a>
    <!--
    <div class="c-header__btnGlobbal c-btnGlobal f-Cal-Reg" @click="triggerLinks">
      <img class="c-btnGlobal__icon" :src="`${assets_path}images/common/logo-global.svg`" alt="CITIZEN GLOBAL NETWORK" width="13" height="13">
      CITIZEN GLOBAL NETWORK
    </div>
    -->
    <a class="c-header__btnSite" :href="urls.citizen" target="_blank">
      <img :src="`${assets_path}images/common/logo-site.svg`" alt="CITIZEN BETTER STARTS NOW" width="105" height="31">
    </a>
  </header>
</template>

<script>
  import { assets_path } from '@/_modules/utils/variables';
  import store from '@/_modules/stores';

  export default {
    components: {

    },
    data() {
      return {
        urls: {},
        assets_path: assets_path,
        isHide: true,
        logoAlt: '',
        logoFile: ''
      }
    },
    store,
    computed: {},
    created() {},
    mounted() {
      this.lang = this.$store.getters.getLang;
      this.urls = this.$store.getters.getUrls;

      if (this.lang === "zh-cmn-Hans") {
        // sc
        this.logoFile = 'logo-st-sc.svg';
        this.logoAlt = '舒博钛';
      } else {
        this.logoFile = 'logo-st.svg';
        this.logoAlt = 'SUPER TITANIUM';
      }
    },
    methods: {
      start() {
        this.isHide = false;
      },
      triggerLinks() {
        if (this.$store.getters.isShowLinks) {
          this.$store.commit('setShowLinks', false);
        } else {
          this.$store.commit('setShowLinks', true);
          this.$store.commit('setShowGnav', false);
        }
      }
    }
  }
</script>
